module.exports = __webpack_public_path__ + "static/img/xinnengyuan4.69ba8c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xinnengyuan4.png
// module id = 8lMI
// module chunks = 16